<template>
  <div :style="{width:width+'px',height:height+'px',color:option.attribute.color,fontSize:option.attribute.fontSize + 'px'}">
    <transition-group name="bounce" appear>
      <div v-for="(row,index) in rollData" :key="row.value" :style="{height:rowHeight+'px',lineHeight:rowHeight+'px',marginTop: index * rowHeight+'px',}" style="position: absolute">
        <div style="width: 100%;overflow-x: hidden;white-space:nowrap;" @click="clickHandler(row.value)" :style="{
              cursor: option.interaction.active  ? 'pointer' : ''
            }">
          <span>{{row.value}}</span>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
import {getDataJson, pollingRefresh} from "@/utils/refresh-cpt-data";
export default {
  name: "cpt-scroll-list",
  props: {
    option: Object,
    width: Number,
    height: Number,
    components: Array
    , current: Object
  },
  computed: {
    dataReload(){
      return this.option.attribute.globalDataReload || [0]
    }
  },
  watch:{
    'option.attribute.showLine':{
      handler() {
        this.computeRowHeight();
        this.scrollTable();
      },
      deep: true//深度监听
    },
    height(){
      this.computeRowHeight();
    },
    "current.cptShow"(val){
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val){
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    }
  },
  data(){
    return {
      uuid: null,
      timer: null,
      rowHeight: 0,
      rollData: [],
      tableData: [],
    }
  },
  created() {
    this.uuid = require('uuid').v1();
    //判断此控件在九宫格里面就不请求数据
    if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 
    // 新增属性兼容旧代码
    if (!this.option.attribute.globalDataReload) {
      this.option.attribute.globalDataReload = [0]
    }
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
    this.computeRowHeight();
  },
  methods:{
    computeRowHeight(){
      this.rowHeight = this.height/this.option.attribute.showLine
    },
    refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
      pollingRefresh(this.uuid, cptDataForm, ()=>this.loadData(cptDataForm,paras),this.components)
    },
    loadData(cptDataForm,paras) {
      getDataJson(cptDataForm,paras,(res)=> {
          this.tableData = res;
          this.scrollTable();
        })
    },
    scrollTable(){
      const that = this;
      if(this.timer){
        clearInterval(this.timer);
      }
      that.rollData = that.tableData.slice(0,this.option.attribute.showLine)
      if(this.option.attribute.showLine >= that.tableData.length){
        return
      }
      let i = this.option.attribute.showLine;
      this.timer = setInterval(()=>{
        that.rollData.shift();
        that.rollData.push(that.tableData[i]);
        i++;
        if(i >= that.tableData.length) {
          i = 0
        }
      }, 2000)
    },
  clickHandler(item) {
      this.$emit("clickHandler", this.option.interaction, 'default', item, 'cpt-scroll-list','',this.current)
    }
  },
  beforeDestroy() {
    clearInterval(this.timer);
  }
}
</script>

<style >
.bounce-enter {
  transform: scaleY(.5);
  transform-origin:100% 100%;
}
.bounce-leave-to {
  opacity: 0;
  transform: translateY(-30px);
}
.bounce-enter-active,.bounce-leave-active {
  transition: all .5s;
}
.bounce-move {
  transition: transform .5s;
}
</style>
